import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export async function getCallRatingsAndFeedback(requestObject) {
  validateUserKey(requestObject.userKey);
  try {
    const { data } = await apiClient.get("api/getCallRatingsAndFeedback", {
      params: requestObject,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}

export async function updateCallRatingFeedback(convID, callRating, callSection, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.put("api/updateCallRatingFeedback", {
      convID,
      callRating,
      callSection,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
